/* eslint-disable angular/window-service */
/* eslint-disable angular/document-service */
export const agGridListingController = (
  $scope,
  userService,
  $uibModal,
  accountPermission,
  $timeout,
  GridApi,
  practiceAreaService,
  $rootScope
) => {
  agGrid.LicenseManager.setLicenseKey(
    'LexStep_Ltd_LEXSTEP__1Devs21_August_2020__MTU5Nzk2NDQwMDAwMA==ccf6c50aaa7d5ba943262bab558d1876'
  )

  $scope.gridOptions.floatingFilter = false
  function setGridSize() {
    const pageHeight = $scope.innerHeight
      ? $scope.innerHeight - 100
      : window.innerHeight
    const agGridListingDiv = document.querySelector(`#${$scope.gridName}`)
    agGridListingDiv.style.width = '100%'
    agGridListingDiv.style.height = pageHeight - 235 + 'px'
  }

  $scope.clearSelection = () => {
    $scope.gridOptions.api.deselectAll()
  }

  $scope.applyFavRules = rule => {
    if (rule.isDefault) {
      const filter = $scope.gridOptions.api.getFilterModel()
      const viewFilter = JSON.parse(rule.filter)
      rule.isApplied = !rule.isApplied
      switch ($scope.gridName) {
        case 'position':
          positionListingFilter(rule, filter, viewFilter)
          break
        case 'candidate':
          candidateListingFilter(rule, filter, viewFilter)
          break
        case 'application':
          applicationListingFilter(rule, filter, viewFilter)
          break
        case 'referral':
          break
        case 'employer':
          employerListingFilter(rule, filter, viewFilter)
          break
        case 'recommendation':
          recommendationListingFilter(rule, filter, viewFilter)
          break
        default:
          break
      }

      $scope.gridOptions.api.setFilterModel(filter)
    } else {
      $scope.setFilterOnGrid(rule)
    }

    $scope.$applyAsync()
  }

  $scope.resetSearchFilter = () => {
    document.querySelector('#filter-text-box').value = ''
    $scope.gridOptions.api.setQuickFilter()

    $scope.groupList.map(item => {
      if (item.isHidden === false && item.parentID !== 'ROOT_NODE_ID')
        item.isHidden = true
      return item
    })
    var elements = document.querySelectorAll('.active')
    ;[].forEach.call(elements, element => {
      element.classList.remove('active')
    })
  }

  $scope.resetOnlyFilter = () => {
    $scope.gridOptions.api.setSortModel([])
    $scope.gridOptions.api.setFilterModel([])
    $scope.savedFilters.map(row => {
      row.isApplied = false
      return row
    })
    $scope.groupList.map(item => {
      if (item.isHidden === false && item.parentID !== 'ROOT_NODE_ID')
        item.isHidden = true
      return item
    })
    var elements = document.querySelectorAll('.active')
    ;[].forEach.call(elements, element => {
      element.classList.remove('active')
    })
    $scope.$broadcast('ag-grid-reset-filters')
  }

  $scope.resetAllFilter = () => {
    $scope.gridOptions.api.deselectAll()
    $scope.gridOptions.columnApi.resetColumnGroupState()
    $scope.gridOptions.api.setSortModel([])
    $scope.gridOptions.api.ensureIndexVisible(0, 'top')
    $scope.savedFilters.map(row => {
      row.isApplied = false
      return row
    })
    $scope.gridOptions.api.setFilterModel([])
    document.querySelector('#filter-text-box').value = ''
    $scope.gridOptions.api.setQuickFilter(
      document.querySelector('#filter-text-box').value
    )
    $scope.groupList.map(item => {
      if (item.isHidden === false && item.parentID !== 'ROOT_NODE_ID')
        item.isHidden = true
      return item
    })
    var elements = document.querySelectorAll('.active')
    ;[].forEach.call(elements, element => {
      element.classList.remove('active')
    })
    $scope.$broadcast('ag-grid-reset-filters')
  }

  $scope.setFilterOnGrid = selectedFilter => {
    if (selectedFilter.isApplied) {
      selectedFilter.isApplied = false
      $scope.gridOptions.columnApi.setColumnState($scope.getColumnStateValue)
      $scope.gridOptions.columnApi.resetColumnGroupState()
      $scope.gridOptions.api.setSortModel([])
      $scope.gridOptions.api.ensureIndexVisible(0, 'top')
      $scope.savedFilters.map(row => {
        row.isApplied = false
        return row
      })
      if ($scope.gridName !== 'MatchingLawyers')
        $scope.gridOptions.api.setFilterModel([])
      document.querySelector('#filter-text-box').value = ''
      $scope.gridOptions.api.setQuickFilter()
      $scope.groupList.map(item => {
        if (item.isHidden === false && item.parentID !== 'ROOT_NODE_ID')
          item.isHidden = true
        return item
      })
      const elements = document.querySelectorAll('.active')
      ;[].forEach.call(elements, element => {
        element.classList.remove('active')
      })
      // $scope.$broadcast('ag-grid-reset-filters')
    } else {
      $scope.savedFilters.map(row => {
        row.isApplied = false
        return row
      })
      selectedFilter.isApplied = true
      const view = selectedFilter.filter
      if (view.columnState) {
        if (view.columnState.group) {
          $scope.gridOptions.columnApi.setColumnState(view.columnState.state)
          $scope.gridOptions.columnApi.setColumnGroupState(
            view.columnState.group
          )
        } else $scope.gridOptions.columnApi.setColumnState(view.columnState)
      }

      if (view.sort) $scope.gridOptions.api.setSortModel(view.sort)
      if (view.filter) $scope.gridOptions.api.setFilterModel(view.filter)
      if (Number(view.index) > 1)
        $scope.gridOptions.api.ensureIndexVisible(
          Math.round(view.index),
          'middle'
        )
    }
  }

  $scope.cvClose = () => {
    $scope.halfGrid({value: false})
  }

  $scope.downloadCV = (path, applicationId) => {
    var a = document.createElement('a')
    document.body.append(a)
    a.style = 'display: none'
    a.href = path
    a.download = `application-${applicationId}`
    a.click()
  }

  $scope.onFilterTextBoxChanged = () => {
    const searchField = document.querySelector('#filter-text-box').value
    $scope.gridOptions.api.setQuickFilter(searchField)
  }

  $scope.openHelp = () => {
    $uibModal.open({
      templateUrl: 'help-modal.html',
      controller: 'HelpModalController',
      controllerAs: 'ctrl',
      resolve: {
        helpModal: function() {
          return $scope.helpTooltip
        },
      },
    })
  }

  $scope.successCallBack = (list, updateStageOnGrid) => {
    $scope.updateDropDownStages({list, updateStageOnGrid})
  }

  const getRulesSavedByUsers = async user => {
    const prepareSavedFiltersUI = savedFiltersResponse => {
      $scope.savedFilters =
        savedFiltersResponse.data.length > 0
          ? savedFiltersResponse.data[0].gridFilters
          : []
      setSavedFilter($scope.savedFilters, $scope.gridName, user)
      const defaultFilter = $scope.savedFilters.find(x => x.default === true)
      $rootScope.$on('listing-loaded', _event => {
        if (defaultFilter) displayDefaultView(defaultFilter)
        $scope.$apply()
      })
    }

    GridApi.getSharedFiltersByGridIdAndPrivateFiltersByUserId(
      $scope.gridName,
      user.id
    )
      .then(prepareSavedFiltersUI)
      .catch()
  }

  const displayDefaultView = defaultFilter => {
    defaultFilter.isApplied = true
    const view = defaultFilter.filter
    if (view.columnState) {
      if (view.columnState.group) {
        $scope.gridOptions.columnApi.setColumnState(view.columnState.state)
        $scope.gridOptions.columnApi.setColumnGroupState(view.columnState.group)
      } else $scope.gridOptions.columnApi.setColumnState(view.columnState)
    }

    if (view.sort) $scope.gridOptions.api.setSortModel(view.sort)
    if (view.filter) $scope.gridOptions.api.setFilterModel(view.filter)
    if (Number(view.index) > 1)
      $scope.gridOptions.api.ensureIndexVisible(
        Math.round(view.index),
        'middle'
      )
    $scope.$applyAsync()
  }

  $scope.gridOnChangePracticeArea = (event, selectedPracticeArea) => {
    if (event) {
      event.stopPropagation()
    } else {
      const currentActiveFilters = $scope.gridOptions.api.getFilterModel()
      const onlyChildrenPractices = practiceAreaService.onlyChildrenPractices(
        $scope.gridActionsDirective.practices.allPracticeAreaList,
        []
      )
      selectedPracticeArea = selectedPracticeArea.map(
        practiceArea => practiceArea.name
      )
      if (onlyChildrenPractices.length === selectedPracticeArea.length) {
        if ($scope.gridName === 'position')
          delete currentActiveFilters.specialtiesName
        else delete currentActiveFilters.legalCandidatePracticeAreas
        $scope.gridOptions.api.setFilterModel(currentActiveFilters)
        $scope.$applyAsync()
      } else {
        if ($scope.gridName === 'position')
          currentActiveFilters.specialtiesName = {
            values: selectedPracticeArea,
            filterType: 'set',
          }
        else
          currentActiveFilters.legalCandidatePracticeAreas = {
            values: selectedPracticeArea,
            filterType: 'set',
          }
        $scope.gridOptions.api.setFilterModel(currentActiveFilters)
        $scope.$applyAsync()
      }
    }
  }

  const applicationColumnFields = [
    'position.type',
    'position.rPQE',
    'id',
    'parentApplicationStage',
    'applicationStage',
    'status',
    'isOffPlatform',
  ]

  $timeout(async () => {
    $scope.user = await userService.getUser()
    getRulesSavedByUsers($scope.user)
    const agGridListingDiv = document.querySelector(`#${$scope.gridName}`)
    // eslint-disable-next-line no-new
    new agGrid.Grid(agGridListingDiv, $scope.gridOptions)
    if ($scope.gridName === 'application')
      $scope.gridOptions.columnApi.autoSizeColumns(applicationColumnFields)
    if ($scope.gridName === 'recommendation')
      $scope.gridOptions.columnApi.autoSizeColumns(['interest'])
    setGridSize()
    $scope.isApplicationStagesSettingAllowed = () => {
      return $scope.user.roles.some(
        role => role.id === 'admin' || role.id === 'ops'
      )
    }

    const columnStateValue = $scope.gridOptions.columnApi.getColumnState()
    $scope.gridOptions.columnApi.getColumnGroupState()
    $scope.getColumnStateValue = columnStateValue
  }, 100)
}

const setSavedFilter = (filters, gridName, user) => {
  switch (gridName) {
    case 'position':
      filters.unshift(
        {
          name: 'My Employers',
          isDefault: true,
          gridId: gridName,
          filter:
            '{"employerAgentEmail":{"values":["' +
            user.email +
            '"],"filterType":"set"}}',
          icon: '/images/myemployers.svg',
        },
        {
          name: 'Private Practice',
          isDefault: true,
          filter:
            '{"employerType":{"values":["Private Practice"],"filterType":"set"}}',
          showOnDropdown: true,
        },
        {
          name: 'In-House',
          isDefault: true,
          filter: '{"employerType":{"values":["In-House"],"filterType":"set"}}',
          showOnDropdown: true,
        }
      )
      break
    case 'candidate':
    case 'recommendation':
      filters.unshift({
        name: 'My Candidates',
        isDefault: true,
        gridId: gridName,
        filter:
          '{"candidateAgentEmail":{"values":["' +
          user.email +
          '"],"filterType":"set"}}',
        icon: '/images/mycandidate.svg',
      })
      break
    case 'employer':
      filters.unshift({
        name: 'My Employers',
        isDefault: true,
        gridId: gridName,
        filter:
          '{"employerAgentEmail":{"values":["' +
          user.email +
          '"],"filterType":"set"}}',
        icon: '/images/myemployers.svg',
      })
      break

    case 'application':
      filters.unshift(
        {
          name: 'My Candidates',
          isDefault: true,
          gridId: gridName,
          filter:
            '{"candidateAgentEmail":{"values":["' +
            user.email +
            '"],"filterType":"set"}}',
          icon: '/images/mycandidate.svg',
        },
        {
          name: 'My Employers',
          isDefault: true,
          gridId: gridName,
          filter:
            '{"employerAgentEmail":{"values":["' +
            user.email +
            '"],"filterType":"set"}}',
          icon: '/images/myemployers.svg',
        }
      )
      break
    default:
      break
  }
}

const positionListingFilter = (rule, filter, viewFilter) => {
  switch (rule.isApplied) {
    case true:
      if (viewFilter.employerAgentEmail)
        filter.employerAgentEmail = viewFilter.employerAgentEmail
      if (viewFilter.employerType) {
        if (filter.employerType)
          viewFilter.employerType.values.push(filter.employerType.values[0])
        filter.employerType = viewFilter.employerType
      }

      break

    default:
      if (viewFilter.employerAgentEmail) delete filter.employerAgentEmail
      if (viewFilter.employerType) {
        if (filter.employerType && filter.employerType.values.length > 1) {
          filter.employerType = filter.employerType.values.filter(
            type => type !== viewFilter.employerType.values[0]
          )
        } else delete filter.employerType
      }

      break
  }
}

const candidateListingFilter = (rule, filter, viewFilter) => {
  switch (rule.isApplied) {
    case true:
      if (viewFilter.candidateAgentEmail)
        filter.candidateAgentEmail = viewFilter.candidateAgentEmail

      break

    default:
      if (viewFilter.candidateAgentEmail) delete filter.candidateAgentEmail

      break
  }
}

const recommendationListingFilter = (rule, filter, viewFilter) => {
  switch (rule.isApplied) {
    case true:
      if (viewFilter.candidateAgentEmail)
        filter.candidateAgentEmail = viewFilter.candidateAgentEmail

      break

    default:
      if (viewFilter.candidateAgentEmail) delete filter.candidateAgentEmail

      break
  }
}

const applicationListingFilter = (rule, filter, viewFilter) => {
  switch (rule.isApplied) {
    case true:
      if (viewFilter.employerAgentEmail)
        filter.employerAgentEmail = viewFilter.employerAgentEmail
      if (viewFilter.candidateAgentEmail)
        filter.candidateAgentEmail = viewFilter.candidateAgentEmail
      break

    default:
      if (viewFilter.employerAgentEmail) delete filter.employerAgentEmail
      if (viewFilter.candidateAgentEmail) delete filter.candidateAgentEmail
      break
  }
}

const employerListingFilter = (rule, filter, viewFilter) => {
  switch (rule.isApplied) {
    case true:
      if (viewFilter.employerAgentEmail)
        filter.employerAgentEmail = viewFilter.employerAgentEmail
      break

    default:
      if (viewFilter.employerAgentEmail) delete filter.employerAgentEmail
      break
  }
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/ag-grid-listing/ag-grid-listing.ctrl.js